import { mesaColorNames, typography } from '@/src/common/theme'
import { Text, View } from 'react-native'
import {
  notificationCenterHorizontalPadding,
  notificationCenterVerticalPadding,
} from '@/src/experiences/notifications/screens/Center'

export function FeedSectionHeader({ title }: { title: string }) {
  return (
    <View
      style={{
        backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
        width: '100%',
        paddingVertical: notificationCenterVerticalPadding,
        paddingHorizontal: notificationCenterHorizontalPadding,
      }}
    >
      <Text
        style={[
          typography['heading/heading6'],
          { color: mesaColorNames['semantic/fg/subtle #898D8F'] },
        ]}
      >
        {title}
      </Text>
    </View>
  )
}
